import { Button, Result } from "antd";
import { Link } from "react-router-dom";

function NotFoundPage() {
  return (
    <Result
      status="404"
      title="404"
      subTitle="Sorry, page is not found."
      extra={
        <Link to="/">
          <Button type="primary">Back Home</Button>
        </Link>
      }
    />
  );
}

export default NotFoundPage;
